import BulbIcon from '@elementor/icons/BulbIcon';
import InfoCircleIcon from '@elementor/icons/InfoCircleIcon';
import AccordionActions from '@elementor/ui/AccordionActions';
import Box from '@elementor/ui/Box';
import Infotip from '@elementor/ui/Infotip';
import Typography from '@elementor/ui/Typography';
import infoTipThumbnail from '@assets/image/thumb-page-structure.png';
import infoTipVideoSrc from '@assets/video/page-structure.webm';
import FixButton from '@components/fix-button';
import GetFreeInfoTip from '@components/get-free-info-tip';
import { uxMessaging } from '@constants/ux-messaging';
import { StyledAlert } from '@styles/app.styles';
import {
	StyledInfoTipBox,
	StyledAccordionDetails,
	StyledSnippet,
	StyledTitleBox,
	StyledFrame,
	StyledFrameText,
	StyledIssueResolveHeading,
} from '@styles/manual-fixes.styles';
import { scannerItem } from '@types/scanner-item';
import { __ } from '@utils/i18n';
import IssueElementSnippetCopyButton from './issue-element-snippet-copy-button';
import IssueResolveExampleLink from './issue-resolve-example-link';

const ManualFixForm = ({ item }) => {
	return (
		<>
			<StyledAccordionDetails>
				<Box>
					<Box display="flex" gap={1} alignItems="center" sx={{ mb: 0.5 }}>
						<Typography variant="subtitle2" as="h5">
							{__('What’s the issue?')}
						</Typography>

						<Infotip
							tabIndex="0"
							placement="top"
							PopperProps={{
								disablePortal: true,
							}}
							content={
								<StyledInfoTipBox>
									<Typography
										variant="subtitle1"
										sx={{ mb: 1, textTransform: 'none' }}
									>
										{__("What's the issue and why it matters?")}
									</Typography>

									<Typography variant="body2">
										{uxMessaging[item.ruleId].whyItMatters}
									</Typography>
								</StyledInfoTipBox>
							}
						>
							<InfoCircleIcon fontSize="small" color="action" />
						</Infotip>
					</Box>

					<Typography variant="body2" color="secondary">
						{uxMessaging[item.ruleId]?.whatsTheIssue ?? item.message}
					</Typography>
				</Box>

				<Box sx={{ mb: 1 }}>
					<StyledTitleBox>
						<Typography variant="subtitle2" as="h5" sx={{ mb: 0.5 }}>
							{__('Affected element:')}
						</Typography>

						<IssueElementSnippetCopyButton snippet={item.snippet} />
					</StyledTitleBox>

					<StyledAlert color="error" icon={false}>
						<Box display="flex" gap={0.5} alignItems="start">
							<StyledSnippet variant="body2">{item.snippet}</StyledSnippet>
						</Box>
					</StyledAlert>
				</Box>

				{uxMessaging[item.ruleId] && (
					<>
						<Box>
							<StyledIssueResolveHeading variant="subtitle2" as="h5">
								<BulbIcon fontSize="small" />

								{__('How to resolve')}
							</StyledIssueResolveHeading>

							<StyledFrame>
								<StyledFrameText variant="body2">
									{uxMessaging[item.ruleId].howToResolve}
								</StyledFrameText>

								<IssueResolveExampleLink ruleId={item.ruleId} />
							</StyledFrame>
						</Box>
					</>
				)}
			</StyledAccordionDetails>

			<AccordionActions sx={{ pt: 1, pb: 3 }}>
				<FixButton
					infoTipContent={
						<GetFreeInfoTip
							videoSrc={infoTipVideoSrc}
							posterSrc={infoTipThumbnail}
							title={__('Fix accessibility issues automatically with Ally')}
							description={__(
								'Ally generates corrected code you can review and apply in one click.',
							)}
						/>
					}
				/>
			</AccordionActions>
		</>
	);
};

ManualFixForm.propTypes = {
	item: scannerItem,
};

export default ManualFixForm;
